import { DefaultFormModel } from '@huggg/react-components';
import { brandedDictionary, hugggOperator } from './recipientBranding';

const getThemeLabel = (themeInfo) =>
  themeInfo?.brandingId ?? themeInfo?.model?.name ?? 'default';

// The redemption form's heading comes from the theme model's `form`, which
// defaults to Huggg's gift wording. A non-Huggg operator swaps in its own copy
// unless theme_info already supplies a `form` of its own. A segment's
// `configuration.formLayout` still overrides both (see Form.tsx).
const getOperatorForm = (operator) => {
  const { formRedemptionDialog } = brandedDictionary(operator);

  return {
    ...DefaultFormModel,
    title: formRedemptionDialog.defaultTitle,
    subtitle: formRedemptionDialog.defaultSubtitle,
  };
};

export const getThemeModelLoader = (
  themeInfo = { label: null },
  operator = hugggOperator,
) => {
  const label = getThemeLabel(themeInfo);
  // A non-Huggg operator gets its own theme namespace so `theme === 'default'`
  // checks (login route, HugggLife) do not apply to it.
  const isHuggg = operator.name === hugggOperator.name;
  const theme = isHuggg ? label : `${operator.name}:${label}`;
  const model = themeInfo?.model ?? {};

  return {
    theme,
    modelLoader: (theme) => {
      return {
        ...model,
        operator,
        ...(operator.showHugggPromotions
          ? {}
          : { shouldShowPoweredByHuggg: false }),
        ...(operator.isWelfare ? { isWelfare: true } : {}),
        ...(isHuggg || model.form ? {} : { form: getOperatorForm(operator) }),
        ...(operator.logoSrc
          ? {
              logo: {
                height: '60px',
                ...model.logo,
                src: model.logo?.src || operator.logoSrc,
              },
            }
          : {}),
        name: theme,
      };
    },
  };
};
